export default "__VITE_PUBLIC_ASSET__42eccd8b__"